import React from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import { IRealEstatePersonalMember, PersonalAccountBlockReason } from '../interfaces';

const REASONS: Record<PersonalAccountBlockReason, string> = {
  DISMISS: 'увольнение',
  BLACK_LIST: 'черный список',
  MANUAL: 'вручную',
  INACTIVITY: 'неактивность',
};

const withUsername = (label: string, username?: string | null) => (username ? `${label} · ${username}` : label);

// Чипу нужны только поля учётки: так его показывает и вкладка «Персонал» карточки ЖК (SERVICE-5560),
// у которой свой, более короткий тип строки.
type AccountFields = Pick<IRealEstatePersonalMember, 'accountStatus' | 'accountUsername' | 'accountBlockReason'>;

const getLabel = (member: AccountFields) => {
  switch (member.accountStatus) {
    case 'ACTIVE':
      return `Учётка: ${member.accountUsername}`;
    case 'BLOCKED':
      return withUsername(
        member.accountBlockReason ? `Заблокирована: ${REASONS[member.accountBlockReason]}` : 'Заблокирована',
        member.accountUsername,
      );
    case 'DELETED':
      return withUsername('Учётка удалена', member.accountUsername);
    default:
      return 'Нет учётки';
  }
};

interface IProps {
  member: AccountFields;
}

// Чип растёт по высоте: в узкой колонке списка длинный статус с логином переносится,
// а не обрезается и не вылезает за рамку.
const useStyles = makeStyles({
  root: { height: 'auto', maxWidth: '100%' },
  label: { whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: 2, paddingBottom: 2, lineHeight: 1.4 },
});

const PersonalAccountChip = ({ member }: IProps) => {
  const classes = useStyles();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={member.accountStatus === 'ACTIVE' ? 'primary' : 'default'}
      label={getLabel(member)}
      classes={{ root: classes.root, label: classes.label }}
    />
  );
};

export default PersonalAccountChip;
